<div
    [class]="
        [
            'flex rounded-14px border border-solid border-gray-3 mob:flex-col w-full bg-white tab:max-w-[700px] mob:max-w-[353px]',
            feature().classNames,
            className(),
        ] | joinClassNames
    "
>
    <div
        class="flex flex-col w-1/2 mob:w-full desk:p-40px gap-y-15px tab:p-5 mob:px-5 mob:py-40px mob:text-center mob:h-full"
    >
        <span class="uppercase text-small-medium tracking-1.5" i18n=":@@features-list-key"
            >List Key Features and Functionalities:
        </span>
        <span class="text-dark text-h4-bold">{{ feature().title }}</span>
        <span class="text-medium-medium text-primary-text-color tab:mb-40px">{{ feature().subtitle }}.</span>
        <div
            [class]="
                [
                    'flex flex-col gap-y-40px',
                    className() ? 'mt-auto desk:mb-80px tab:mb-100px mob:mt-25px' : 'mt-auto tab:mt-25px mob:mt-135px',
                ] | joinClassNames
            "
        >
            <a
                i18n="@@button-get-started"
                routerLink="/pricing"
                class="button-primary desk:w-fit tab:w-full mob:w-full"
            >
                Get Started
            </a>
            <ng-content />
        </div>
    </div>
    <div class="flex justify-center w-1/2 mob:w-full px-45px py-35px tab:px-15px tab:py-5 mob:px-5 mob:pb-5 mob:pt-0">
        <img
            [ngSrc]="feature().screenShot | asset: 'features/our-features' : 'webp'"
            width="509"
            height="362"
            alt="screen"
            class="border border-solid border-gray-3 rounded-6px"
        />
    </div>
</div>
